<script setup>
// Pausa do agente na barra superior — sempre à vista, em qualquer tela, com ou
// sem módulo de ligações. Aparece só com o agente pausado (Ocupado) E com
// motivos de pausa ativos na conta: motivo, cronômetro e limite. Conta sem
// motivos cadastrados usa "Ocupado" como sempre foi — só um status, sem selo. Passou do limite do motivo: fica vermelha e o agente
// SEGUE pausado — nada é encerrado sozinho. Pausar é pelo menu de status do
// perfil (ou pelo discador); retomar é aqui.
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import { useAgentPause } from './useAgentPause';

const { t } = useI18n();
const {
  options,
  isPaused,
  label,
  clock,
  limitLabel,
  limitTooltip,
  isOverdue,
  isChanging,
  resume,
} = useAgentPause();
</script>

<template>
  <div
    v-if="isPaused && options.length"
    class="flex items-center gap-2 h-8 ltr:pl-2.5 rtl:pr-2.5 ltr:pr-1 rtl:pl-1 rounded-lg outline outline-1 min-w-0 max-w-xs"
    :class="
      isOverdue
        ? 'bg-n-ruby-3 outline-n-ruby-6 text-n-ruby-11'
        : 'bg-n-amber-3 outline-n-amber-6 text-n-amber-11'
    "
    data-test-id="agent-pause-chip"
  >
    <span
      class="size-3.5 flex-shrink-0"
      :class="isOverdue ? 'i-lucide-alarm-clock' : 'i-lucide-pause-circle'"
    />
    <span class="truncate text-xs font-medium">{{ label }}</span>
    <span
      v-tooltip="limitTooltip"
      class="flex-shrink-0 font-mono text-xs tabular-nums"
      :class="{ 'font-semibold': isOverdue }"
    >
      {{ clock }}
      <template v-if="limitLabel">/ {{ limitLabel }}</template>
    </span>
    <Button
      size="xs"
      variant="faded"
      :color="isOverdue ? 'ruby' : 'amber'"
      class="flex-shrink-0"
      :is-loading="isChanging"
      :label="t('AGENT_PAUSE.BAR.RESUME')"
      @click="resume"
    />
  </div>
</template>
